import {FC} from "react";
import {useOutletContext} from "react-router-dom";
import { UnityVehicleControlTabContent } from "./content";
import { Unity } from "../../../../domain/unity";

export const UnityVehicleControlTab: FC<any> = () => {
    const unity = useOutletContext<Unity>();
    return <UnityVehicleControlTabContent unity={unity}/>;
};
